module.exports = __webpack_public_path__ + "img/xu.435dbb7f.gif";